import { render } from "./SelectDatasource.vue?vue&type=template&id=238a7f08&scoped=true&ts=true"
import script from "./SelectDatasource.vue?vue&type=script&lang=ts"
export * from "./SelectDatasource.vue?vue&type=script&lang=ts"

import "./SelectDatasource.vue?vue&type=style&index=0&id=238a7f08&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238a7f08"]])

export default __exports__